import React from "react";
import { func, bool } from "prop-types";

import { CheckboxButton } from "../../../../common/index";

import { isSmallerThanDesktop } from "../../../../helpers";
import { useWindowDimensions } from "../../../../helpers/hooks";

const WorkHoursOptions = ({
  hasSelectedFullTimeHours,
  hasSelectedPartTimeHours,
  hasSelectedBothHours,
  toggleHours,
  toggleBothHours,
}) => {
  const { width } = useWindowDimensions();

  return (
    <div className="my-2">
      <h3>What type of work hours are you looking for?</h3>
      <div
        className={`${
          isSmallerThanDesktop(width) ? "btn-group-vertical" : "btn-group"
        } clearfix d-block`}
      >
        <CheckboxButton
          isChecked={hasSelectedFullTimeHours}
          onClick={() => toggleHours("full")}
          label="Full time"
        />
        <CheckboxButton
          isChecked={hasSelectedPartTimeHours}
          onClick={() => toggleHours("part")}
          label="Part time"
        />
        <CheckboxButton
          isChecked={hasSelectedBothHours}
          onClick={toggleBothHours}
          label="Both"
        />
      </div>
    </div>
  );
};

WorkHoursOptions.propTypes = {
  hasSelectedBothHours: bool.isRequired,
  hasSelectedFullTimeHours: bool.isRequired,
  hasSelectedPartTimeHours: bool.isRequired,
  toggleHours: func.isRequired,
  toggleBothHours: func.isRequired,
};

export default WorkHoursOptions;
